import React from 'react';
import {
    House, Storefront, FirstAid, GraduationCap,
    Buildings, Factory, Ticket, Bank,
    ThermometerCold, Wind, Engine, Fire, Wrench,
    CookingPot, Cake, WashingMachine, Lightning, ChefHat
} from "@phosphor-icons/react";

export const sectors = [
    {
        title: "1. Residencial",
        icon: <House />,
        items: ["Casas habitación", "Departamentos", "Residenciales privados", "Etc."]
    },
    {
        title: "2. Comercio Local y Negocios",
        icon: <Storefront />,
        items: ["Alimentos y bebidas", "Cafeterías", "Restaurantes", "Panaderías", "Pastelerías", "Carnicerías", "Pescaderías", "Neverías", "Heladerías", "Etc."]
    },
    {
        title: "3. Salud y Servicios Críticos",
        icon: <FirstAid />,
        items: ["Consultorios médicos", "Clínicas privadas", "Laboratorios", "Dentistas", "Hospitales privados", "Centros de rehabilitación", "Clínicas veterinarias", "Etc."]
    },
    {
        title: "4. Educación",
        icon: <GraduationCap />,
        items: ["Guarderías", "Escuelas privadas", "Colegios", "Universidades", "Institutos técnicos", "Academias", "Etc."]
    },
    {
        title: "5. Cadenas y Franquicias",
        icon: <Buildings />,
        items: ["Restaurantes en cadena", "Cafeterías en cadena", "Franquicias de comida rápida", "Tiendas de conveniencia", "Grupos restauranteros", "Cadenas de farmacias", "Cadenas de gimnasios", "Cadenas de lavanderías", "Grupos comerciales regionales", "Holdings empresariales", "Etc."]
    },
    {
        title: "6. Industria Ligera y Logística",
        icon: <Factory />,
        items: ["Naves industriales", "Parques industriales", "Centros de distribución (CEDIS)", "Almacenes", "Plantas de empaque", "Procesadoras de alimentos", "Etc."]
    },
    {
        title: "7. Entretenimiento y Eventos",
        icon: <Ticket />,
        items: ["Cines", "Teatros", "Auditorios", "Salones de eventos", "Etc."]
    },
    {
        title: "8. Sector Público e Instituciones",
        icon: <Bank />,
        items: ["Ayuntamientos", "Dependencias estatales", "Dependencias federales", "Escuelas públicas", "Hospitales públicos", "Universidades públicas", "Etc."]
    }
];

export const equipmentCategories = [
    {
        title: "I. Refrigeración Comercial",
        icon: <ThermometerCold />,
        items: ["Refrigeradores domésticos", "Refrigeradores comerciales verticales", "Refrigeradores horizontales", "Vitrinas refrigeradas", "Exhibidores refrigerados", "Cámaras frías pequeñas", "Enfriadores de bebidas", "Enfriadores cerveceros", "Conservadores de helados", "Neveras comerciales", "Refrigeradores farmacéuticos", "Cámaras de congelación", "Cámaras de conservación", "Cámaras de maduración", "Unidades condensadoras", "Unidades evaporadoras", "Sistemas split de refrigeración", "Sistemas centralizados", "Refrigeración especializada", "Cámaras para carne/pescado/fruta", "Refrigeración para laboratorios y hospitales", "Bancos de hielo", "Túneles de congelación (básico)"]
    },
    {
        title: "II. Refrigeración Industrial",
        icon: <Engine />,
        items: ["Sistemas de refrigeración centralizada", "Compresores semiherméticos", "Compresores herméticos", "Compresores abiertos", "Compresores de tornillo", "Compresores scroll", "Compresores reciprocantes", "Torres de enfriamiento"]
    },
    {
        title: "III. Aire Acondicionado y Climatización",
        icon: <Wind />,
        items: ["Minisplit e Inverter", "Ventana y Portátil", "Split muro / piso-techo / cassette", "Multi-split", "Paquete (Package) y Roof Top", "Sistemas VRF / VRV", "Fan & Coil", "Manejadoras de aire", "Sistemas de volumen variable", "Sistemas de expansión directa", "Sistemas HVAC industriales", "Chillers de aire y agua", "Sistemas de agua helada", "Sistemas de presurización", "Control de humedad y temperatura crítica", "Sistemas de ventilación industrial"]
    },
    {
        title: "IV. Equipos de Cocción Comercial",
        icon: <CookingPot />,
        items: ["Estufas y parrillas industriales", "Planchas de gas y eléctricas", "Asadores y freidoras", "Hornos de gas y eléctricos", "Hornos de convección y combinados", "Salamandras", "Marmitas", "Sartenes basculantes", "Cocinas de inducción"]
    },
    {
        title: "V. Panadería y Pastelería",
        icon: <Cake />, // Cambio a icono de pastel
        items: ["Hornos de panadería", "Hornos rotativos y de pisos", "Fermentadoras", "Cámaras de fermentación", "Batidoras industriales", "Amasadoras", "Divisoras y Laminadoras", "Cámaras de reposo"]
    },
    {
        title: "VI. Equipos Auxiliares de Cocina",
        icon: <ChefHat />, // Cambio a icono de gorro de chef
        items: ["Campanas extractoras y extractores", "Sistemas de ventilación y filtros", "Trampas de grasa", "Lavavajillas y lavalozas industriales", "Máquinas de hielo", "Mesas frías y calientes", "Baños maría"]
    },
    {
        title: "VII. Lavado, Secado y Procesos",
        icon: <WashingMachine />,
        items: ["Lavadoras y secadoras industriales", "Planchadoras y calandras", "Prensas", "Equipos y generadores de vapor", "Calderas (básico)"]
    },
    {
        title: "VIII. Equipos Eléctricos y Control",
        icon: <Lightning />,
        items: ["Tableros eléctricos", "Centros de carga", "Contactores", "Variadores de frecuencia", "Arrancadores suaves", "Protecciones eléctricas", "Sensores de temperatura", "Presostatos", "Termostatos", "Sistemas de control"]
    }
];